import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DeviceDefinitionRepo } from "../../../repos";
import { DeviceFieldDefinitionEntity } from "../../../entities/device";
import { DeviceWidgetEventStruct } from "./device-widget-event.struct";
import { WidgetBase } from "../widget-base";
import { WidgetEnum } from "../../../enums";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef, ModalOptions } from "ngx-bootstrap/modal";

@Component({
  selector: "device-field-widget",
  template: `
    <div class="device-field-widget" *ngIf="!entity">
      <widget-spinner></widget-spinner>
    </div>
    <ng-container *ngIf="entity">
      <ng-container [ngSwitch]="layout">
        <!-- ================================================= -->
        <!-- Mini                                              -->
        <!-- ================================================= -->
        <div class="device-field-widget" *ngSwitchCase="'mini'">
          [Device Field.mini]
        </div>

        <!-- ================================================= -->
        <!-- Brief                                             -->
        <!-- ================================================= -->
        <div class="device-field-widget" *ngSwitchCase="'brief'">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  Field Definition
                  <b
                    ><a
                      [routerLink]="[
                        '/portal/device/field/definitions/' + entity.identifier
                      ]"
                      title="{{ entity.identifier }}"
                      ><i class="pr-1 text-dark fa fa-link"></i>
                      {{ entity.identifier }}</a
                    ></b
                  >
                </div>
                <div class="card-body p-2">
                  <ng-container *ngTemplateOutlet="standard"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- Standard                                          -->
        <!-- ================================================= -->
        <div class="device-field-widget" *ngSwitchCase="'standard'">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header font-weight-bold">
                  Field Definition
                  <b
                    ><a
                      [routerLink]="[
                        '/portal/device/field/definitions/' + entity.identifier
                      ]"
                      title="{{ entity.identifier }}"
                      ><i class="pr-1 text-dark fa fa-link"></i>
                      {{ entity.identifier }}</a
                    ></b
                  >
                </div>
                <div class="card-body p-2">
                  <ng-container *ngTemplateOutlet="standard"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- shadowbox                                          -->
        <!-- ================================================= -->
        <div class="device-field-widget" *ngSwitchCase="'shadowbox'">
          <ng-container *ngTemplateOutlet="standard"></ng-container>
        </div>

        <!-- ================================================= -->
        <!-- Sidebar                                           -->
        <!-- ================================================= -->
        <div class="device-field-widget" *ngSwitchCase="'sidebar'">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  Field Definition
                  <b
                    ><a
                      [routerLink]="[
                        '/portal/device/field/definitions/' + entity.identifier
                      ]"
                      title="{{ entity.identifier }}"
                      ><i class="pr-1 text-dark fa fa-link"></i>
                      {{ entity.identifier }}</a
                    ></b
                  >
                </div>
                <div class="card-body p-2">
                  <ng-container *ngTemplateOutlet="standard"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- Table                                             -->
        <!-- ================================================= -->

        <ng-container *ngSwitchCase="'nested-header'">
          [Device Field: Nested Headers]
        </ng-container>

        <ng-container *ngSwitchCase="'table'">
          <div
            class="device-entity-widget row"
            *ngIf="options['index'] == 0 && options['header']"
          >
            <ng-container *ngFor="let column of options.columns">
              <ng-container [ngSwitch]="column">
                <div class="col-2  div-table-th" *ngSwitchCase="'identifier'">
                  Id
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'name'">
                  Name
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'handle'">
                  Handle
                </div>
                <div class="col-1  div-table-th" *ngSwitchCase="'unit'">
                  Unit
                </div>
                <div class="col-1  div-table-th" *ngSwitchCase="'high'">
                  High
                </div>
                <div class="col-1  div-table-th" *ngSwitchCase="'low'">Low</div>
                <div class="col-1  div-table-th" *ngSwitchCase="'width'">
                  Width
                </div>
                <div class="col-1  div-table-th" *ngSwitchCase="'derived'">
                  Derived
                </div>
                <div class="col-1  div-table-th" *ngSwitchCase="'variant'">
                  Variant
                </div>
                <!-- <div class="col  div-table-th" *ngSwitchCase="'actions'">Actions</div> -->
              </ng-container>
            </ng-container>
          </div>

          <div class="row">
            <ng-container *ngFor="let column of options.columns">
              <ng-container [ngSwitch]="column">
                <div
                  class="col-2 text-nowrap"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'identifier'"
                >
                  <a
                    [routerLink]="[
                      '/portal/device/field/definitions/' + entity.identifier
                    ]"
                    title="{{ entity.identifier }}"
                    ><i class="pr-1 text-dark fa fa-link"></i></a
                  >&nbsp;<a
                    title="{{ entity.identifier }}"
                    href="'/portal/device/field/definitions/'  + entity.identifier"
                    (click)="showEditModal(standard, entity, $event)"
                    >{{ entity.identifier }}</a
                  >
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'name'"
                >
                  {{ entity.name }}
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'handle'"
                >
                  {{ entity.handle }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'unit'"
                >
                  {{ entity.unit }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'high'"
                >
                  {{ entity.rangeHigh }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'low'"
                >
                  {{ entity.rangeLow }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'width'"
                >
                  {{ entity.width }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'derived'"
                >
                  {{ entity.is_derived_type }}
                </div>
                <div
                  class="col-1"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'variant'"
                >
                  {{ entity.is_variant_type }}
                </div>

                <!-- <div class="col" [ngClass]="{'div-table-tr-alt': (options['index'] % 2), 'div-table-tr': !(options['index'] % 2) }"  *ngSwitchCase="'actions'">
              [actions]
            </div> -->
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'nested-table'">
          [Device Field: Nested Table]
        </ng-container>

        <div class="device-entity-widget" *ngSwitchDefault>
          [Device Default.default {{ layout | json }}]
        </div>
      </ng-container>
    </ng-container>

    <ng-template #standard>
      <div
        class="modal-header d-flex justify-content-between align-items-center bg-light"
      >
        <h4 class="modal-title m-0 h5 font-weight-bold">
          {{ currentModal?.title }}
        </h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="deviceTypeListModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div
        *ngIf="currentModal?.errorMsg"
        class="alert alert-danger mx-3 mt-3 mb-0 py-2"
      >
        <i class="fa fa-exclamation-circle me-2"></i
        >{{ currentModal?.errorMsg }}
      </div>

      <!-- Not Loaded -->
      <div class="card mb-3 mx-3 mt-3" *ngIf="!entity">
        <div
          class="card-header d-flex justify-content-between align-items-center bg-light"
        >
          <strong>Field Definition:</strong> Loading
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="card-body text-center py-4">
          <widget-spinner></widget-spinner>
        </div>
      </div>

      <!-- Loaded Content -->
      <div class="px-3 pt-3" *ngIf="entity">
        <!-- Field Details -->
        <div class="card mb-3">
          <div class="card-header bg-light">
            <strong>Field Details</strong>
          </div>
          <div class="card-body">
            <!-- Name -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Name:
              </div>
              <div class="col-md-9 col-8">{{ entity.name }}</div>
            </div>

            <!-- Handle -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Handle:
              </div>
              <div class="col-md-9 col-8">
                {{ entity.handle }}
              </div>
            </div>

            <!-- Type -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Type:
              </div>
              <div class="col-md-9 col-8">{{ entity.type }}</div>
            </div>

            <!-- Unit -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Unit:
              </div>
              <div class="col-md-9 col-8">{{ entity.unit || "N/A" }}</div>
            </div>

            <!-- Derived Type -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Derived Type:
              </div>
              <div class="col-md-9 col-8">
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-success': entity.is_derived_type,
                    'bg-secondary': !entity.is_derived_type
                  }"
                >
                  {{ entity.is_derived_type ? "Yes" : "No" }}
                </span>
              </div>
            </div>

            <!-- Variant Type -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Variant Type:
              </div>
              <div class="col-md-9 col-8">
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-success': entity.is_variant_type,
                    'bg-secondary': !entity.is_variant_type
                  }"
                >
                  {{ entity.is_variant_type ? "Yes" : "No" }}
                </span>
              </div>
            </div>

            <!-- Precision -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Precision:
              </div>
              <div class="col-md-9 col-8">{{ entity.precision || "N/A" }}</div>
            </div>

            <!-- Accuracy -->
            <div class="row mb-2 align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Accuracy:
              </div>
              <div class="col-md-9 col-8">{{ entity.accuracy || "N/A" }}</div>
            </div>

            <!-- Range -->
            <div class="row align-items-center">
              <div
                class="col-md-3 col-4 font-weight-bold text-muted font-weight-bold"
              >
                Range:
              </div>
              <div class="col-md-9 col-8">
                {{ entity.rangeLow || "N/A" }} - {{ entity.rangeHigh || "N/A" }}
              </div>
            </div>
          </div>
        </div>

        <!-- Formulas -->
        <div class="card mb-3">
          <div
            class="card-header d-flex justify-content-between align-items-center bg-light"
          >
            <strong>Formulas</strong>
            <button
              *ngIf="options"
              class="btn btn-sm btn-outline-primary"
              (click)="toggleExpand()"
            >
              <i
                class="fa fa-sm me-1"
                [ngClass]="{
                  'fa-chevron-down': !expand,
                  'fa-chevron-up': expand
                }"
              ></i>
              {{ expand ? "Collapse" : "Expand" }}
            </button>
          </div>
          <div class="card-body" *ngIf="expand">
            <!-- Stage 1 -->
            <div class="mb-3">
              <h6 class="font-weight-bold text-muted mb-2">Stage 1:</h6>
              <div
                *ngIf="entity.stageOneFormula"
                class="text-white p-3 rounded"
                style="background: #f8f3f2;"
              >
                <pre class="m-0">{{
                  entity.stageOneFormula.toJson() | json
                }}</pre>
              </div>
              <div *ngIf="!entity.stageOneFormula" class="text-muted">
                No formula defined
              </div>
            </div>

            <!-- Stage 2 -->
            <div class="mb-3">
              <h6 class="font-weight-bold text-muted mb-2">Stage 2:</h6>
              <div
                *ngIf="entity.stageTwoFormula"
                class="text-white p-3 rounded"
                style="background: #f8f3f2;"
              >
                <pre class="m-0">{{
                  entity.stageTwoFormula.toJson() | json
                }}</pre>
              </div>
              <div *ngIf="!entity.stageTwoFormula" class="text-muted">
                No formula defined
              </div>
            </div>

            <!-- Stage 3 -->
            <div>
              <h6 class="font-weight-bold text-muted mb-2">Stage 3:</h6>
              <div
                *ngIf="entity.stageThreeFormula"
                class="text-white p-3 rounded"
                style="background: #f8f3f2;"
              >
                <pre class="m-0">{{
                  entity.stageThreeFormula.toJson() | json
                }}</pre>
              </div>
              <div *ngIf="!entity.stageThreeFormula" class="text-muted">
                No formula defined
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-danger"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  `,
})
export class DeviceFieldWidgetComponent extends WidgetBase implements OnInit {
  @Input() entity: DeviceFieldDefinitionEntity = null;
  @Input() templateHint: string = null;
  @Input() options: any = {};
  @Input() layout = "standard";
  @Output() widgetEvent = new EventEmitter<DeviceWidgetEventStruct>();
  forwardEvent(e, widgetEvent: DeviceWidgetEventStruct) {
    e.preventDefault();
    this.widgetEvent.emit(widgetEvent);
  }

  public expandLogs = false;
  public expandUsers = false;
  public fetchedUsers = false;
  public currentModal: any;
  public expand = false;
  public deviceTypeListModalRef: BsModalRef;
  constructor(
    public typeRepo: DeviceDefinitionRepo,
    public modalService: BsModalService
  ) {
    super();
  }

  toggleExpand() {
    this.expand = !this.expand;
  }

  public select(event) {
    let a = new DeviceWidgetEventStruct();
    a.event_body = this.entity;
    a.event_type = "select_entity";
    a.event_widget_type = WidgetEnum.EMBED_WIDGET__DEVICE_FIELD;
    this.forwardEvent(event, a);
  }

  public editTypeModal = {
    title: "Field Definition",
    msg: `Field Definition.`,
    errorMsg: null,
    processing: false,
    form: "field-definition",
    cancelMsg: "Cancel",
    cancel: () => {
      this.editTypeModal.errorMsg = null;
      this.deviceTypeListModalRef.hide();
    },
  };

  public showEditModal(modal, entry: DeviceFieldDefinitionEntity, event) {
    event.preventDefault();
    this.currentModal = this.editTypeModal;
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
      class: "lg-modal",
    };
    this.deviceTypeListModalRef = this.modalService.show(modal, config);
  }

  ngOnInit(): void {}
}
